import { Reveal } from "./Reveal";
import { PROCESS_STEPS } from "../lib/data";

export const Process = () => (
  <section id="process" className="relative py-20 sm:py-28 lg:py-32" data-testid="process-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-2xl mb-14 sm:mb-20">
        <span className="font-mono text-xs uppercase tracking-[0.25em] text-laser">
          // How We Work
        </span>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-white mt-4">
          How We Work
        </h2>
      </Reveal>

      {/* Desktop horizontal timeline */}
      <div className="hidden lg:grid grid-cols-6 gap-4 relative">
        <div className="absolute top-6 left-0 right-0 h-px bg-gradient-to-r from-transparent via-border-subtle to-transparent" />
        {PROCESS_STEPS.map((step, i) => (
          <Reveal key={step.step} delay={i * 0.1} className="relative">
            <div className="flex flex-col">
              <div className="h-12 w-12 rounded-full border border-laser/40 bg-card-dark flex items-center justify-center font-mono text-laser text-sm font-medium relative z-10 shadow-[0_0_20px_-6px_rgba(0,240,255,0.6)]">
                {step.step}
              </div>
              <h3 className="font-display text-base font-semibold text-white mt-5 mb-2">
                {step.title}
              </h3>
              <p className="text-slate-400 text-sm leading-relaxed">{step.description}</p>
            </div>
          </Reveal>
        ))}
      </div>

      {/* Mobile / tablet vertical timeline */}
      <div className="lg:hidden relative pl-8">
        <div className="absolute left-[23px] top-2 bottom-2 w-px bg-gradient-to-b from-electric/60 via-border-subtle to-transparent" />
        <div className="space-y-10">
          {PROCESS_STEPS.map((step, i) => (
            <Reveal key={step.step} delay={i * 0.08} className="relative">
              <div className="absolute -left-8 top-0 h-10 w-10 rounded-full border border-laser/40 bg-card-dark flex items-center justify-center font-mono text-laser text-xs font-medium shadow-[0_0_16px_-6px_rgba(0,240,255,0.6)]">
                {step.step}
              </div>
              <div className="ml-4">
                <h3 className="font-display text-lg font-semibold text-white mb-1.5">
                  {step.title}
                </h3>
                <p className="text-slate-400 text-sm leading-relaxed">{step.description}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
